define('waproductfastview', ['jquery'], function ($) {

  var waproductfastview = {
    js_fastview: function js_fastview() {
      var _this = this;

      this.template = $('#fastview__template').html(), this.fastviewBtn = $('.js_fastviewBtn'), this.fastviewJSWrapper = $('#js_fastview'), this.fastviewWrapper = $('#js_fastview .fastview'), this.fastviewBtn.unbind('click').on('click', function (e) {
        e.preventDefault();
        _this.getProductData($(e.currentTarget));
      });
    },
    getProductData: function getProductData(self) {
      var productItem = self.closest('.product__item');
      var productItemHref = productItem.find('.product__link').attr('href');
      var productItemThumbs = '';
      var productItemBigImg = productItem.find('.product__image--big').get(0).outerHTML.replace(new RegExp(/\sdata-src=/gm), 'src').replace(new RegExp(/\ssrcset=".*?"/gm), '').replace('384_384_80', '780_780_80').replace('384_267_80', '680_472_80');
      var productItemHeadline = productItem.find('.product__headline').html();
      var productItemSubline = productItem.find('.product__subline').html();
      var productItemPrice = productItem.find('.product__price').html();
      var productItemInfoBtn = productItem.find('.info-btn-area').html();
      var productItemDelivery = productItem.find('.product__delivery').html();
      var productItemRating = productItem.find('.rating').hasClass('rating__0') ? '' : productItem.find('.rating').html();
      var thumbObj = productItem.attr('data-pics') ? productItem.data('pics')['thumbs'] : false;

      if (!!thumbObj) {
        $.each(thumbObj, function (i, val) {
          var img = val.replace('166_166_80', '780_780_80').replace('166_115_80', '680_472_80');
          if (i == 1) {
            productItemBigImg = '<img src="' + img + '" alt="">';
          }
          productItemThumbs += '<li><img src="' + img + '" alt=""></li>';
        });
      }

      var el = $(waproductfastview.template.replace(new RegExp('__fastview_image__', 'gm'), productItemBigImg != void 0 ? productItemBigImg : "").replace(new RegExp('__fastview_thumbnails__', 'gm'), productItemThumbs != void 0 ? productItemThumbs : "").replace(new RegExp('__fastview_headline__', 'gm'), productItemHeadline != void 0 ? productItemHeadline : "").replace(new RegExp('__fastview_subline__', 'gm'), productItemSubline != void 0 ? productItemSubline : "").replace(new RegExp('__fastview_infobtn__', 'gm'), productItemInfoBtn != void 0 ? productItemInfoBtn : "").replace(new RegExp('__fastview_price__', 'gm'), productItemPrice != void 0 ? productItemPrice : "").replace(new RegExp('__fastview_delivery__', 'gm'), productItemDelivery != void 0 ? productItemDelivery : "").replace(new RegExp('__fastview_rating__', 'gm'), productItemRating != void 0 ? productItemRating : "").replace(new RegExp('__fastview_detailsHref__', 'gm'), productItemHref != void 0 ? productItemHref : ""));

      var detailsButton = el.find('.fastview__details--btn');
      detailsButton.html(detailsButton.data('translation'));

      if (productItemRating != void 0) {
        var productRating = el.find('.rating');
        var productRatingList = productRating.find('.rating__list');
        var ratingListCSSWidth = productRatingList.width();
        var ratingtCurrentSVG = productRatingList.find('.rating__current--svg');
        var ratingtCurrentSVGClipRight = ratingtCurrentSVG.data('clipright');
        productRatingList.css('width', ratingListCSSWidth * 2 + 'px');
        ratingtCurrentSVG.css('clip', 'rect(0px, ' + parseInt(ratingtCurrentSVGClipRight) * 2 + 'px, 20px, 0px)');
      }

      this.fastviewWrapper.html('').append(el) && this.fastviewJSWrapper.trigger('click');

      if (!!thumbObj) waproductfastview.js_showThumbnails();
    },
    js_showThumbnails: function js_showThumbnails() {

      $('.fastview__thumbnails--list li img').mouseover(function () {
        var self = $(this);
        var thumbSrc = self.attr('src');
        var bigImg = $('.fastview__image img');
        bigImg.attr('src', thumbSrc);
      });
    }
  };

  return waproductfastview;
});

